import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import { startRootSaga } from "./store/sagas/rootSaga";
import { getRouterBasename } from "./utilities/navigationUtils";

import "./index.css";

import App from "./App";

startRootSaga();

// Prevent pinch zoom
window.addEventListener(
    "touchstart",
    event => {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    },
    { capture: false, passive: false }
);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
    <Provider store={store}>
        <BrowserRouter basename={getRouterBasename(window.location.pathname)}>
            <App />
        </BrowserRouter>
    </Provider>
);
